/**
 * Theme-level analytics events for CPAP Discount Warehouse.
 * Publishes Shopify analytics events that the Custom Pixel subscribes to.
 */
(function () {
  'use strict';

  // Track product card clicks (select_item)
  document.addEventListener('click', function (e) {
    var card = e.target.closest('[data-product-card]');
    if (!card) return;

    var dataEl = card.querySelector('.analytics-product-data');
    if (!dataEl) return;

    try {
      var product = JSON.parse(dataEl.textContent);
      window.Shopify?.analytics?.publish('custom_select_item', product);
    } catch (err) {}
  });

  // Track cart drawer open (view_cart)
  document.addEventListener('cart:update', function () {
    window.Shopify?.analytics?.publish('custom_view_cart');
  });

  // Track search usage
  var searchForms = document.querySelectorAll('form[action="/search"]');
  searchForms.forEach(function (form) {
    form.addEventListener('submit', function () {
      var input = form.querySelector('input[name="q"]');
      if (input && input.value) {
        window.Shopify?.analytics?.publish('custom_search', {
          query: input.value,
        });
      }
    });
  });
})();
